import { Link } from 'react-router-dom';

export default function TbitInvoicesLandingPage() {
  return (
    <div className="min-h-screen bg-base-200 flex items-center justify-center px-4">
      <div className="max-w-lg text-center space-y-8">
        <div>
          <h1 className="text-4xl font-bold text-primary">TBIT Invoices</h1>
          <p className="text-lg text-base-content/70 mt-2">
            AI-powered invoice processing for NetSuite
          </p>
        </div>

        <div className="space-y-4 text-left">
          <div className="card bg-base-100 shadow-sm">
            <div className="card-body py-4">
              <h3 className="font-semibold">Automatic extraction</h3>
              <p className="text-sm text-base-content/70">
                AI reads incoming invoices from email and extracts vendor, amounts, line items, and tax breakdown.
              </p>
            </div>
          </div>
          <div className="card bg-base-100 shadow-sm">
            <div className="card-body py-4">
              <h3 className="font-semibold">NetSuite integration</h3>
              <p className="text-sm text-base-content/70">
                Extracted invoices are matched to vendors and expense categories, then pushed as bills directly into NetSuite.
              </p>
            </div>
          </div>
          <div className="card bg-base-100 shadow-sm">
            <div className="card-body py-4">
              <h3 className="font-semibold">Inbox monitoring</h3>
              <p className="text-sm text-base-content/70">
                Continuously monitors a designated inbox for new invoices — no manual uploads needed.
              </p>
            </div>
          </div>
        </div>

        <Link to="/tbit-invoices/connect" className="btn btn-primary btn-lg">
          Get Started
        </Link>
      </div>
    </div>
  );
}
